import React, { useCallback } from 'react';
import { useFieldActions } from '../../../contexts/field-actions-context';
import { useFieldValidation } from '../../../contexts/field-validation-context';
import { useForm } from '../../../contexts/form-context';
import { Form } from '../../../ui/form/components/form';
import { useFormFields } from '../../../ui/form/contexts/form-fields-context';
const NO_VALUES = {};
const NO_ERRORS = [];
const NestedForm = _ref => {
  let {
    id,
    form,
    value,
    onChange,
    errors,
    FieldLayout
  } = _ref;
  const formSchema = useForm();
  const {
    validateFields
  } = useFieldValidation();
  const fieldActions = useFieldActions();
  const fields = useFormFields();
  const handleFieldChange = useCallback((target, subFieldValue) => {
    onChange == null || onChange({
      ...value,
      [target]: subFieldValue
    });
  }, [onChange, value]);
  if (!form) {
    return null;
  }
  return /*#__PURE__*/React.createElement(FieldLayout, {
    fieldId: id
  }, /*#__PURE__*/React.createElement(Form, {
    formSchema: formSchema,
    form: form,
    values: value ?? NO_VALUES,
    onFieldChange: handleFieldChange,
    errors: errors ?? NO_ERRORS,
    validateFields: validateFields,
    fieldActions: fieldActions,
    fields: fields
  }));
};
export default NestedForm;
//# sourceMappingURL=nested-form.js.map